import React from 'react';

const Bone = ({ className = '' }) => <span className={`skeleton-bone ${className}`} aria-hidden="true" />;

const LoadingShell = ({ label, className = '', children }) => (
  <div className={`skeleton-shell ${className}`} role="status" aria-live="polite" aria-label={label}>
    {children}
    <span className="sr-only">{label}</span>
  </div>
);

export const CardSkeleton = () => (
  <div className="video-card skeleton-card" aria-hidden="true">
    <div className="video-card-link">
      <Bone className="skeleton-card__art" />
      <div className="video-card-info">
        <Bone className="skeleton-line skeleton-line--title" />
        <div className="skeleton-card__meta"><Bone className="skeleton-line skeleton-line--short" /></div>
        <Bone className="skeleton-line skeleton-line--price" />
      </div>
    </div>
  </div>
);

export const SkeletonCard = CardSkeleton;

export function HomeSkeleton() {
  return (
    <LoadingShell label="Loading the catalogue" className="home-page skeleton-home">
      {[0, 1].map((section) => (
        <section className="videos-section" key={section}>
          <Bone className="skeleton-heading" />
          <div className="videos-grid">{[0, 1, 2, 3].map((card) => <CardSkeleton key={card} />)}</div>
        </section>
      ))}
    </LoadingShell>
  );
}

export function DetailSkeleton() {
  return (
    <LoadingShell label="Loading title details" className="detail-page">
      <div className="detail-container skeleton-detail">
        <Bone className="skeleton-detail__media" />
        <div className="skeleton-detail__copy">
          <Bone className="skeleton-line skeleton-detail__title" />
          <div className="skeleton-detail__meta"><Bone /><Bone /><Bone /></div>
          <Bone className="skeleton-line" /><Bone className="skeleton-line" /><Bone className="skeleton-line skeleton-line--medium" />
          <Bone className="skeleton-detail__price" /><Bone className="skeleton-button" />
        </div>
      </div>
    </LoadingShell>
  );
}

export function SeriesSkeleton() {
  return (
    <LoadingShell label="Loading series details" className="cinema-page skeleton-series">
      <section className="series-hero skeleton-series__hero">
        <div className="series-hero__content skeleton-series__copy">
          <Bone className="skeleton-line skeleton-line--short" /><Bone className="skeleton-series__title" />
          <div className="skeleton-detail__meta"><Bone /><Bone /><Bone /></div>
          <Bone className="skeleton-line skeleton-line--medium" /><Bone className="skeleton-line skeleton-line--medium" /><Bone className="skeleton-button" />
        </div>
      </section>
      <main className="series-library">
        <Bone className="skeleton-heading" />
        <div className="episode-rail">{[0, 1, 2].map((episode) => <div className="episode-tile skeleton-episode" key={episode}><Bone className="skeleton-episode__art" /><Bone className="skeleton-line skeleton-line--medium" /></div>)}</div>
      </main>
    </LoadingShell>
  );
}

export function PaymentSkeleton() {
  return (
    <LoadingShell label="Loading checkout" className="payment-page">
      <div className="payment-container skeleton-payment">
        <Bone className="skeleton-heading skeleton-payment__heading" />
        <div className="payment-item"><Bone className="skeleton-payment__art" /><div className="payment-item-info"><Bone className="skeleton-line skeleton-line--title" /><Bone className="skeleton-line skeleton-line--medium" /><Bone className="skeleton-line skeleton-line--price" /></div></div>
        <Bone className="skeleton-line skeleton-line--medium" /><Bone className="skeleton-input" /><Bone className="skeleton-button skeleton-button--full" />
      </div>
    </LoadingShell>
  );
}

export function WatchSkeleton() {
  return (
    <LoadingShell label="Preparing your stream" className="movie-watch skeleton-watch">
      <header className="movie-watch__bar"><Bone className="skeleton-line skeleton-line--short" /><div><Bone className="skeleton-line skeleton-line--short" /><Bone className="skeleton-line skeleton-line--title" /></div></header>
      <Bone className="movie-screen skeleton-watch__screen" />
      <div className="movie-watch__meta"><Bone className="skeleton-line skeleton-line--medium" /><Bone className="skeleton-line skeleton-line--medium" /></div>
    </LoadingShell>
  );
}
